"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class ErgoAlgoSegment {
  static thaw(ergoAlgoSegmentObj) {
    if (ergoAlgoSegmentObj == null) return null;
    const ergoAlgoSegment = new ErgoAlgoSegment();
    if (ergoAlgoSegmentObj.id != null) ergoAlgoSegment.setId(ergoAlgoSegmentObj.id);
    if (ergoAlgoSegmentObj.name != null) ergoAlgoSegment.setName(ergoAlgoSegmentObj.name);
    if (ergoAlgoSegmentObj.evaluationSections != null) ergoAlgoSegment.setEvaluationSections(_.EvaluationSection.thawList(ergoAlgoSegmentObj.evaluationSections));
    if (ergoAlgoSegmentObj.evaluationVersions != null) ergoAlgoSegment.setEvaluationVersions(_.EvaluationVersion.thawList(ergoAlgoSegmentObj.evaluationVersions));
    if (ergoAlgoSegmentObj.appVersions != null) ergoAlgoSegment.setAppVersions(_.AppVersion.thawList(ergoAlgoSegmentObj.appVersions));
    if (ergoAlgoSegmentObj.ergonars != null) ergoAlgoSegment.setErgonars(_.Ergonar.thawList(ergoAlgoSegmentObj.ergonars));
    if (ergoAlgoSegmentObj.evaluations != null) ergoAlgoSegment.setEvaluations(_.Evaluation.thawList(ergoAlgoSegmentObj.evaluations));
    if (ergoAlgoSegmentObj.evaluatorCertifications != null) ergoAlgoSegment.setEvaluatorCertifications(_.EvaluatorCertification.thawList(ergoAlgoSegmentObj.evaluatorCertifications));
    if (ergoAlgoSegmentObj.requiredTrainingModules != null) ergoAlgoSegment.setRequiredTrainingModules(_.TrainingModule.thawList(ergoAlgoSegmentObj.requiredTrainingModules));
    if (ergoAlgoSegmentObj.hasPurchasedTraining != null) ergoAlgoSegment.setHasPurchasedTraining(ergoAlgoSegmentObj.hasPurchasedTraining);
    if (ergoAlgoSegmentObj.hasActiveSubscription != null) ergoAlgoSegment.setHasActiveSubscription(ergoAlgoSegmentObj.hasActiveSubscription);
    if (ergoAlgoSegmentObj.hasMetSegmentRequirements != null) ergoAlgoSegment.setHasMetSegmentRequirements(ergoAlgoSegmentObj.hasMetSegmentRequirements);
    if (ergoAlgoSegmentObj.isCoveredByGroup != null) ergoAlgoSegment.setIsCoveredByGroup(ergoAlgoSegmentObj.isCoveredByGroup);
    if (ergoAlgoSegmentObj.shortDescription != null) ergoAlgoSegment.setShortDescription(ergoAlgoSegmentObj.shortDescription);
    if (ergoAlgoSegmentObj.longDescription != null) ergoAlgoSegment.setLongDescription(ergoAlgoSegmentObj.longDescription);
    if (ergoAlgoSegmentObj.displayImageUrl != null) ergoAlgoSegment.setDisplayImageUrl(ergoAlgoSegmentObj.displayImageUrl);
    if (ergoAlgoSegmentObj.trainingCost != null) ergoAlgoSegment.setTrainingCost(ergoAlgoSegmentObj.trainingCost);
    if (ergoAlgoSegmentObj.subscriptionCost != null) ergoAlgoSegment.setSubscriptionCost(ergoAlgoSegmentObj.subscriptionCost);
    if (ergoAlgoSegmentObj.monthlySubscriptionCost != null) ergoAlgoSegment.setMonthlySubscriptionCost(ergoAlgoSegmentObj.monthlySubscriptionCost);
    if (ergoAlgoSegmentObj.trainingBillingDescription != null) ergoAlgoSegment.setTrainingBillingDescription(ergoAlgoSegmentObj.trainingBillingDescription);
    if (ergoAlgoSegmentObj.subscriptionBillingDescription != null) ergoAlgoSegment.setSubscriptionBillingDescription(ergoAlgoSegmentObj.subscriptionBillingDescription);
    if (ergoAlgoSegmentObj.subscriptionTiers != null) ergoAlgoSegment.setSubscriptionTiers(_.SubscriptionTier.thawList(ergoAlgoSegmentObj.subscriptionTiers));
    return ergoAlgoSegment;
  }

  static thawList(ergoAlgoSegmentObjList) {
    if (ergoAlgoSegmentObjList == null) return [];
    var ergoAlgoSegments = [];

    for (var i = 0; i < ergoAlgoSegmentObjList.length; i++) {
      ergoAlgoSegments.push(ErgoAlgoSegment.thaw(ergoAlgoSegmentObjList[i]));
    }

    return ergoAlgoSegments;
  }

  static freeze(ergoAlgoSegment) {
    if (ergoAlgoSegment == null) return null;
    var ergoAlgoSegmentObj = {};
    if (ergoAlgoSegment.getId() != null) ergoAlgoSegmentObj.id = ergoAlgoSegment.getId();
    if (ergoAlgoSegment.getName() != null) ergoAlgoSegmentObj.name = ergoAlgoSegment.getName();
    if (ergoAlgoSegment.getEvaluationSections() != null) ergoAlgoSegmentObj.evaluationSections = _.EvaluationSection.freezeList(ergoAlgoSegment.getEvaluationSections());
    if (ergoAlgoSegment.getEvaluationVersions() != null) ergoAlgoSegmentObj.evaluationVersions = _.EvaluationVersion.freezeList(ergoAlgoSegment.getEvaluationVersions());
    if (ergoAlgoSegment.getAppVersions() != null) ergoAlgoSegmentObj.appVersions = _.AppVersion.freezeList(ergoAlgoSegment.getAppVersions());
    if (ergoAlgoSegment.getErgonars() != null) ergoAlgoSegmentObj.ergonars = _.Ergonar.freezeList(ergoAlgoSegment.getErgonars());
    if (ergoAlgoSegment.getEvaluations() != null) ergoAlgoSegmentObj.evaluations = _.Evaluation.freezeList(ergoAlgoSegment.getEvaluations());
    if (ergoAlgoSegment.getEvaluatorCertifications() != null) ergoAlgoSegmentObj.evaluatorCertifications = _.EvaluatorCertification.freezeList(ergoAlgoSegment.getEvaluatorCertifications());
    if (ergoAlgoSegment.getRequiredTrainingModules() != null) ergoAlgoSegmentObj.requiredTrainingModules = _.TrainingModule.freezeList(ergoAlgoSegment.getRequiredTrainingModules());
    if (ergoAlgoSegment.getHasPurchasedTraining() != null) ergoAlgoSegmentObj.hasPurchasedTraining = ergoAlgoSegment.getHasPurchasedTraining();
    if (ergoAlgoSegment.getHasActiveSubscription() != null) ergoAlgoSegmentObj.hasActiveSubscription = ergoAlgoSegment.getHasActiveSubscription();
    if (ergoAlgoSegment.getHasMetSegmentRequirements() != null) ergoAlgoSegmentObj.hasMetSegmentRequirements = ergoAlgoSegment.getHasMetSegmentRequirements();
    if (ergoAlgoSegment.getIsCoveredByGroup() != null) ergoAlgoSegmentObj.isCoveredByGroup = ergoAlgoSegment.getIsCoveredByGroup();
    if (ergoAlgoSegment.getShortDescription() != null) ergoAlgoSegmentObj.shortDescription = ergoAlgoSegment.getShortDescription();
    if (ergoAlgoSegment.getLongDescription() != null) ergoAlgoSegmentObj.longDescription = ergoAlgoSegment.getLongDescription();
    if (ergoAlgoSegment.getDisplayImageUrl() != null) ergoAlgoSegmentObj.displayImageUrl = ergoAlgoSegment.getDisplayImageUrl();
    if (ergoAlgoSegment.getTrainingCost() != null) ergoAlgoSegmentObj.trainingCost = ergoAlgoSegment.getTrainingCost();
    if (ergoAlgoSegment.getSubscriptionCost() != null) ergoAlgoSegmentObj.subscriptionCost = ergoAlgoSegment.getSubscriptionCost();
    if (ergoAlgoSegment.getMonthlySubscriptionCost() != null) ergoAlgoSegmentObj.monthlySubscriptionCost = ergoAlgoSegment.getMonthlySubscriptionCost();
    if (ergoAlgoSegment.getTrainingBillingDescription() != null) ergoAlgoSegmentObj.trainingBillingDescription = ergoAlgoSegment.getTrainingBillingDescription();
    if (ergoAlgoSegment.getSubscriptionBillingDescription() != null) ergoAlgoSegmentObj.subscriptionBillingDescription = ergoAlgoSegment.getSubscriptionBillingDescription();
    if (ergoAlgoSegment.getSubscriptionTiers() != null) ergoAlgoSegmentObj.subscriptionTiers = _.SubscriptionTier.freezeList(ergoAlgoSegment.getSubscriptionTiers());
    return ergoAlgoSegmentObj;
  }

  static freezeList(ergoAlgoSegments) {
    if (ergoAlgoSegments == null) return [];
    var ergoAlgoSegmentObjList = [];

    for (var i = 0; i < ergoAlgoSegments.length; i++) {
      ergoAlgoSegmentObjList.push(ErgoAlgoSegment.freeze(ergoAlgoSegments[i]));
    }

    return ergoAlgoSegmentObjList;
  }

  constructor() {
    this.setId(null);
    this.setName(null);
    this.setEvaluationSections(null);
    this.setEvaluationVersions(null);
    this.setAppVersions(null);
    this.setErgonars(null);
    this.setEvaluations(null);
    this.setEvaluatorCertifications(null);
    this.setRequiredTrainingModules(null);
    this.setHasPurchasedTraining(null);
    this.setHasActiveSubscription(null);
    this.setShortDescription(null);
    this.setLongDescription(null);
    this.setDisplayImageUrl(null);
    this.setTrainingCost(null);
    this.setSubscriptionCost(null);
    this.setMonthlySubscriptionCost(null);
    this.setTrainingBillingDescription(null);
    this.setSubscriptionBillingDescription(null);
    this.setIsCoveredByGroup(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setName(name) {
    this.name = name;
  }

  setEvaluationSections(evaluationSections) {
    this.evaluationSections = evaluationSections;
  }

  setEvaluationVersions(evaluationVersions) {
    this.evaluationVersions = evaluationVersions;
  }

  setAppVersions(appVersions) {
    this.appVersions = appVersions;
  }

  setErgonars(ergonars) {
    this.ergonars = ergonars;
  }

  setEvaluations(evaluations) {
    this.evaluations = evaluations;
  }

  setEvaluatorCertifications(evaluatorCertifications) {
    this.evaluatorCertifications = evaluatorCertifications;
  }

  setRequiredTrainingModules(requiredTrainingModules) {
    this.requiredTrainingModules = requiredTrainingModules;
  }

  setHasPurchasedTraining(hasPurchasedTraining) {
    this.hasPurchasedTraining = hasPurchasedTraining;
  }

  setHasActiveSubscription(hasActiveSubscription) {
    this.hasActiveSubscription = hasActiveSubscription;
  }

  setHasMetSegmentRequirements(hasMetSegmentRequirements) {
    this.hasMetSegmentRequirements = hasMetSegmentRequirements;
  }

  setShortDescription(shortDescription) {
    this.shortDescription = shortDescription;
  }

  setLongDescription(longDescription) {
    this.longDescription = longDescription;
  }

  setDisplayImageUrl(displayImageUrl) {
    this.displayImageUrl = displayImageUrl;
  }

  setTrainingCost(trainingCost) {
    this.trainingCost = trainingCost;
  }

  setSubscriptionCost(subscriptionCost) {
    this.subscriptionCost = subscriptionCost;
  }

  setMonthlySubscriptionCost(monthlySubscriptionCost) {
    this.monthlySubscriptionCost = monthlySubscriptionCost;
  }

  setTrainingBillingDescription(trainingBillingDescription) {
    this.trainingBillingDescription = trainingBillingDescription;
  }

  setSubscriptionBillingDescription(subscriptionBillingDescription) {
    this.subscriptionBillingDescription = subscriptionBillingDescription;
  }

  setSubscriptionTiers(subscriptionTiers) {
    this.subscriptionTiers = subscriptionTiers;
  }

  setIsCoveredByGroup(isCoveredByGroup) {
    this.isCoveredByGroup = isCoveredByGroup;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getEvaluationSections() {
    return this.evaluationSections;
  }

  getEvaluationVersions() {
    return this.evaluationVersions;
  }

  getAppVersions() {
    return this.appVersions;
  }

  getErgonars() {
    return this.ergonars;
  }

  getEvaluations() {
    return this.evaluations;
  }

  getEvaluatorCertifications() {
    return this.evaluatorCertifications;
  }

  getRequiredTrainingModules() {
    return this.requiredTrainingModules;
  }

  getHasPurchasedTraining() {
    return this.hasPurchasedTraining;
  }

  getHasActiveSubscription() {
    return this.hasActiveSubscription;
  }

  getHasMetSegmentRequirements() {
    return this.hasMetSegmentRequirements;
  }

  getShortDescription() {
    return this.shortDescription;
  }

  getLongDescription() {
    return this.longDescription;
  }

  getDisplayImageUrl() {
    return this.displayImageUrl;
  }

  getTrainingCost() {
    return this.trainingCost;
  }

  getSubscriptionCost() {
    return this.subscriptionCost;
  }

  getMonthlySubscriptionCost() {
    return this.monthlySubscriptionCost;
  }

  getTrainingBillingDescription() {
    return this.trainingBillingDescription;
  }

  getSubscriptionBillingDescription() {
    return this.subscriptionBillingDescription;
  }

  getSubscriptionTiers() {
    return this.subscriptionTiers;
  }

  getIsCoveredByGroup() {
    return this.isCoveredByGroup;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = ErgoAlgoSegment;